<template>
    <v-container fluid class="pa-0" style="background-color: white;">
        <v-row no-gutters>

            <v-col cols="6" class="pa-3">
                <h2 class="mb-3">Import data</h2>

                <ImportVisualizer :importInProgress="importInProgress" :progressText="importProgressText" :importError="importError"
                    :importSuccess="importSuccess"
                    @reset="importInProgress = false; importError = null; importSuccess = null;">
                </ImportVisualizer>

                <div class="mx-3">
                    <QTextField v-model="errorEmail" label=" Send email on import success to" disabled>
                    </QTextField>
                    <QTextField v-model="successEmail" label=" Send email on import error to" disabled>
                    </QTextField>
                </div>

                <ImportSamples />
            </v-col>

            <v-divider vertical style="z-index: 1;"></v-divider>

            <v-col cols="6">
                <ImportHistory ref="History" />
            </v-col>

        </v-row>
    </v-container>
</template>


<script>
import ClientAPIMixin from '@/api/ClientAPIMixin';
import SRConst from "@/helpers/Constants/SignalRConstants.js";
import ImportVisualizer from './ImportVisualizer.vue';
import ImportHistory from './ImportHistory.vue';
import ImportSamples from './ImportSamples.vue';
import SettingsConstants from "@/helpers/Constants/SettingsConstants";
import SettingsMixin from '@/views/admin/settings/default-settings/SettingsMixin';

export default {
    name: 'Import',
    props: {},
    components: {
        ImportVisualizer,
        ImportHistory,
        ImportSamples,
    },
    mixins: [ClientAPIMixin, SettingsMixin],

    data() {
        return {
            importInProgress: false,
            importProgressText: null,
            importError: null,
            importSuccess: null,

            subscriptions: [
                { eventKey: SRConst.EventKeys.ImportProgressEvent, handler: this.handleImportProgress },
                { eventKey: SRConst.EventKeys.ImportFailedEvent, handler: this.handleImportFailed },
                { eventKey: SRConst.EventKeys.ImportSuccessEvent, handler: this.handleImportSuccess }
            ],

            isLoading: false,
            settingList: [
                SettingsConstants.ApiImportFailedEmail,
                SettingsConstants.ApiImportSucceededEmail,
                SettingsConstants.ImportExportImportProgress,
            ],
        };
    },

    mounted() {
        this.subscribe();
        this.fetch();
    },

    beforeDestroy() {
        this.unsubscribe();
    },

    methods: {
        subscribe() {
            this.subscriptions.forEach(e => {
                this.$store.dispatch("NotificationStore/subscribe", [e.eventKey, e.handler]);
            });
        },

        unsubscribe() {
            this.subscriptions.forEach(e => {
                this.$store.dispatch("NotificationStore/unsubscribe", [e.eventKey, e.handler]);
            });
        },

        handleImportProgress(args) {
            this.importError = null;
            this.importSuccess = null;
            this.importInProgress = true;
            //console.log("Import progress", args);
            this.importProgressText = args.message;
        },
        handleImportSuccess(args) {
            this.importSuccess = args;
            this.importInProgress = false;
            console.log("Import success", args);
            this.refreshHistory();
        },
        handleImportFailed(args) {
            this.importError = args;
            this.importInProgress = false;
            console.log("Import failed", args);
            this.refreshHistory();
        },

        refreshHistory() {
            this.$refs.History.fetch();
        },


        async fetch() {
            var groups = new Set(this.settingList.map(obj => obj.group));
            this.isLoading = true;

            await ClientAPIMixin.methods.getSettingsListByGroup({ groups: [...groups] }).then(response => {
                //map the setting values from the reponse onto the setting list items
                this.settingList.forEach(setting => {
                    var newVal = response[setting.group.toLowerCase()][setting.settingKey];
                    this.settingValueFromString(setting, newVal)
                });

                //TODO: interpret settings to see if last import was in progress
                var lastStatus = this.settingList.find(x => x.settingKey == SettingsConstants.ImportExportImportProgress.settingKey);
                if (lastStatus && lastStatus.value != "End Import") {
                    console.warn("Last import is not complete.");
                    this.importInProgress = true;
                }
                this.isLoading = false;
            });
        },
    },

    computed: {
        errorEmail() {
            var setting = this.settingList.find(x => x.settingKey == SettingsConstants.ApiImportFailedEmail.settingKey);
            return setting ? setting.value : "";
        },
        successEmail() {
            var setting = this.settingList.find(x => x.settingKey == SettingsConstants.ApiImportSucceededEmail.settingKey);
            return setting ? setting.value : "";
        },
    },

    watch: {},
};
</script>


<style lang='scss' scoped></style>